import { LINE_CONFIG } from "./line-config.js";

export function expandProfile(profile: any, lineId?: string): any {
  if (!profile) return profile;

  // Clone to avoid side effects on original config objects
  const expanded = { ...profile };

  let refStops: string[] = [];
  if (lineId) {
    const lineConfig = (LINE_CONFIG as Record<string, any>)[lineId];
    if (lineConfig && Array.isArray(lineConfig.referenceStops)) {
      refStops = lineConfig.referenceStops;
    }
  }

  // 1. If compactStops is omitted or incomplete, derive it from referenceStops
  if (!expanded.compactStops) {
    expanded.compactStops = {
      outbound: refStops.length > 0 ? [refStops[refStops.length - 1]] : [],
      return: refStops.length > 0 ? [refStops[0]] : []
    };
  } else {
    expanded.compactStops = { ...expanded.compactStops };
    if (!expanded.compactStops.outbound && refStops.length > 0) {
      expanded.compactStops.outbound = [refStops[refStops.length - 1]];
    }
    if (!expanded.compactStops.return && refStops.length > 0) {
      expanded.compactStops.return = [refStops[0]];
    }
  }

  // 2. detailStops defaults to referenceStops (or compactStops) if omitted
  if (!expanded.detailStops) {
    expanded.detailStops = {
      outbound: refStops.length > 0 ? [...refStops] : (expanded.compactStops.outbound || []),
      return: refStops.length > 0 ? [...refStops].reverse() : (expanded.compactStops.return || [])
    };
  } else {
    expanded.detailStops = { ...expanded.detailStops };
    if (!expanded.detailStops.outbound) {
      expanded.detailStops.outbound = refStops.length > 0 ? [...refStops] : (expanded.compactStops.outbound || []);
    }
    if (!expanded.detailStops.return) {
      expanded.detailStops.return = refStops.length > 0 ? [...refStops].reverse() : (expanded.compactStops.return || []);
    }
  }

  // Ensure timetableStops is defined
  if (!expanded.timetableStops) {
    expanded.timetableStops = {};
  } else {
    expanded.timetableStops = { ...expanded.timetableStops };
  }

  const dayTypes = ["weekday", "saturday", "sunday"];
  const directions = ["outbound", "return"];

  for (const day of dayTypes) {
    for (const dir of directions) {
      const scheduleKey = `${day}_${dir}`;
      if (!expanded.timetableStops[scheduleKey]) {
        // Fallback hierarchy:
        // 1. timetableStops[dir]
        // 2. detailStops[dir]
        // 3. compactStops[dir]
        // 4. referenceStops (if matching dir)
        let fallback =
          expanded.timetableStops[dir] ||
          (expanded.detailStops && expanded.detailStops[dir]) ||
          (expanded.compactStops && expanded.compactStops[dir]);
        if (!fallback && refStops.length > 0) {
          fallback = dir === "return" ? [...refStops].reverse() : [...refStops];
        }
        if (fallback) {
          expanded.timetableStops[scheduleKey] = [...fallback];
        }
      }
    }
  }

  return expanded;
}
